import { DEFAULT_LOCALE } from '../config';

const getInitialsFromMultipleWords = (name: string) => {
  return name
    .split(' ')
    .filter((word) => word.trim())
    .map((word) => word[0].toUpperCase() + '.')
    .join(' ');
};

type NameConfig = {
  userLocale?: string;
  shortFirstName?: boolean;
  shortLastName?: boolean;
};

export const getName = (
  firstName: string = ' ',
  lastName: string = ' ',
  config?: NameConfig,
): string => {
  const {
    userLocale = DEFAULT_LOCALE,
    shortFirstName = false,
    shortLastName = false,
  } = config || {};

  const firstNameInitials = getInitialsFromMultipleWords(firstName);
  const lastNameInitials = getInitialsFromMultipleWords(lastName);

  const first = shortFirstName ? firstNameInitials : firstName;
  const last = shortLastName ? lastNameInitials : lastName;

  if (userLocale === 'ru' || userLocale === 'uk') {
    return `${last} ${first}`;
  }

  return `${first} ${last}`;
};
